import React, { useMemo } from "react";


export default function ToothTopFront({ surface, tooth, handleClick }: { surface: any, tooth: any, handleClick: (e: any) => void }) {
    const clipPathId = useMemo(() => `tooth-top-front-clip-${Math.random().toString(36).substring(2, 15)}`, []);

    return (
        <svg
            viewBox="0 0 260 200"
            width="39px"
            height="43px"
        >
            <defs>
                <clipPath id={clipPathId}>
                    <path d="M 25 145 Q 5 100 25 55 Q 45 35 85 35 L 200 35 Q 235 35 245 100 Q 235 165 200 165 L 85 165 Q 45 165 25 145 Z" />
                </clipPath>
            </defs>
            <path d="M 25 145 Q 5 100 25 55 Q 45 35 85 35 L 200 35 Q 235 35 245 100 Q 235 165 200 165 L 85 165 Q 45 165 25 145 Z" fill="red" />
            <g clipPath={`url(#${clipPathId})`}>
                <polygon
                    key="polygon-1"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinejoin="round"
                    points="125,100 25,165 15,100 25,35"
                    fill={surface[3]?.color}
                    onClick={() => handleClick(surface[3])}

                   
                />
                <polygon
                    key="polygon-2"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinejoin="round"
                    points="125,100 245,35 245,165"
                    fill={surface[1]?.color}
                    onClick={() => handleClick(surface[1])}
                />
                <polygon
                    key="polygon-3"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinejoin="round"
                    points="125,100 245,165 25,165"
                    fill={surface[2]?.color}
                    onClick={() => handleClick(surface[2])}
                />
                <polygon
                    key="polygon-4"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinejoin="round"
                    points="125,100 245,35 25,35"
                    fill={surface[0]?.color}
                    onClick={() => handleClick(surface[0])}
                />
            </g>
            <path
                d="M 25 145 Q 5 100 25 55 Q 45 35 85 35 L 200 35 Q 235 35 245 100 Q 235 165 200 165 L 85 165 Q 45 165 25 145 Z"
                fill="none"
                stroke="#000000"
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
